module.exports = __webpack_public_path__ + "static/img/nx.291237b3.webp";